import React, { useCallback, useState } from 'react';
import { useParams } from 'react-router-dom';
//Components 
import Checkout from './components/Checkout';
import HeaderMain from '../Home/Headers/HeaderMain';
//Exporting the main component of the shopping cart, which is the checkout page. This component will be used in the main app to render the checkout page when the user clicks on the shopping cart icon. The checkout page will display the items in the cart, the total price, and a button to proceed to payment. The checkout page will also have a form to enter the shipping address and payment information. The checkout page will be styled using CSS and will be responsive to different screen sizes.
export const ShoppingCart = () => {
   const { PreOrder_id } = useParams();
   //States 
   const [theme, setTheme] = useState("light");
   const [headerenabledOpcionLimit, setHeaderenabledOpcionLimit] = useState(false);
   const handleCheckoutContextReady = useCallback(({ theme: checkoutTheme }) => {
      setTheme(checkoutTheme || "light");
      setHeaderenabledOpcionLimit(true);
   }, []);
   return (
      <div className='ecommerce-wrapper'>
         {/** Header Component */}
         <HeaderMain
            themeinit={theme}
            buttonShopavailable={false}
            headerenabledOpcionLimit={headerenabledOpcionLimit}
            showDirectOrderContext={Boolean(PreOrder_id)}
         />
         {/** Checkout Component */}
         <Checkout onContextReady={handleCheckoutContextReady} />
      </div>
   );
}

export default ShoppingCart;
